import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import "@/index.css";
import "./presets/themes/nocturne.css";
import App from "@/App";
import { BrandProvider } from "@/config/branding";
import { warmStaticAssets } from "@/utils/warmStaticAssets";
import StartupPageRecovery from "@/components/StartupRecovery";
import { startReadinessMonitor } from "@/utils/startupReadiness";

if (!Array.prototype.at) {
    Object.defineProperty(Array.prototype, "at", {
        value(index) {
            const length = this == null ? 0 : this.length >>> 0;
            let i = Math.trunc(index) || 0;
            if (i < 0) i += length;
            return i < 0 || i >= length ? undefined : this[i];
        },
        configurable: true,
        writable: true,
    });
}

if (!Object.hasOwn) {
    Object.hasOwn = (obj, key) =>
        Object.prototype.hasOwnProperty.call(Object(obj), key);
}

if (!window.structuredClone) {
    window.structuredClone = (value) => JSON.parse(JSON.stringify(value));
}

const root = ReactDOM.createRoot(document.getElementById("root"));
startReadinessMonitor();
root.render(
    <React.StrictMode>
        <StartupPageRecovery>
        <HelmetProvider>
            <BrandProvider>
                <App />
            </BrandProvider>
        </HelmetProvider>
        </StartupPageRecovery>
    </React.StrictMode>,
);

// Public shell caching starts after first paint, including signed-out launch.
// Preserve whichever existing worker handles this origin's push subscription.
if ("serviceWorker" in navigator) {
    navigator.serviceWorker.addEventListener("controllerchange", () => warmStaticAssets());
    window.requestAnimationFrame(() => {
        navigator.serviceWorker.getRegistration("/")
            .then((reg) => reg ? reg.update() : navigator.serviceWorker.register("/sw.js", { updateViaCache: "none" }))
            .then(() => navigator.serviceWorker.ready)
            .then((reg) => warmStaticAssets(reg.active))
            .catch(() => {});
    });
}
